/* __next_internal_client_entry_do_not_use__ default auto */import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./error.module.css";
import { Translate } from "@/components/topic/Translate";
import Image from "next/image";
import errorIcon from "@/assets/image/error_page.png";
const NextNotFound = () => {
  return /*#__PURE__*/_jsxs("div", {
    className: styles.error_page_container,
    children: [/*#__PURE__*/_jsx(Image, {
      className: styles.error_page_icon,
      src: errorIcon,
      alt: "error icon",
      width: 140,
      height: 124
    }), /*#__PURE__*/_jsx("p", {
      className: styles.error_page_title,
      children: /*#__PURE__*/_jsx(Translate, {
        translateKey: "Common_NotFound_Title"
      })
    }), /*#__PURE__*/_jsx("p", {
      className: styles.error_page_desc,
      children: /*#__PURE__*/_jsx(Translate, {
        translateKey: "Common_NotFound_Text"
      })
    }), /*#__PURE__*/_jsx("button", {
      onClick: () => {
        window.location.href = "/";
      },
      className: styles.error_page_button,
      children: /*#__PURE__*/_jsx(Translate, {
        translateKey: "Common_NotFound_Link"
      })
    })]
  });
};
export default NextNotFound;